module.exports = __webpack_public_path__ + "static/img/RWA.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/RWA.png
// module id = Xdge
// module chunks = 0